import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { getPendingOrderReports } from '@data'
import { showLoader } from '@data/state/action'
import { CardDetail, MainWrapper, Wrapper } from '../CompanyReport'
import { strings } from '@constants'
import { H4 } from '@base'
import { Table as TableV2, Button as ButtonV2 } from '@baseV2'
import { ItemWrapper } from '@pages/Dashboard/styles'
import { Spacings } from '@styles'
import { Business, Eco, FilterDrama, FitnessCenter, Grain, Money } from '@material-ui/icons'
import { convertDataFile, dataArrayToCsv } from '@utils'

const TableWrapper = styled(ItemWrapper)`
	width: 100%;
	& > div:nth-child(1) {
		margin-bottom: ${Spacings.SPACING_3B};
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
`

const TableHeading = styled(H4)``

const PendingOrderReports = () => {
	const dispatch = useDispatch()
	const [cardList, setCardList] = useState([])
	const [reportsData, setReportsData] = useState([])

	// TODO -> platforms changed
	const getCardIcon = (key) => {
		switch (key) {
			case 'RECYCLING':
				return <Grain />
			case 'MARKETPLACE':
				return <Business />
			case 'CLOUD_FACTORY':
				return <FilterDrama />
			case 'NON_FERROUS':
				return <Eco />
			case 'TOTAL':
				return <FitnessCenter />
			default:
				return <Money />
		}
	}

	useEffect(() => {
		dispatch(showLoader(true))
		getPendingOrderReports()
			.then((response) => {
				setCardList(Object.entries(response?.by_platform).map(([key, value]) => ({ key, value })))
				let xyz = []
				Object.entries(response).map(([key, value]) => {
					if (Array.isArray(value)) {
						xyz.push({ key: key, value: value })
					}
				})
				setReportsData(xyz)
			})
			.catch((error) => { })
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [])

	const getColumns = (key) => {
		let tableColumns
		switch (key) {
			case 'by_region':
				tableColumns = [
					{ label: 'Business Region', key: 'region', mobile: true, sortable: false },
					{ label: 'NON FERROUS', key: 'NON_FERROUS', mobile: true, sortable: false },
					{ label: 'FERROUS', key: 'FERROUS', mobile: true, sortable: false },
					{ label: 'CLOUD FACTORY', key: 'CLOUD_FACTORY', mobile: true, sortable: false },
					{ label: 'SOLAR', key: 'SOLAR', mobile: true, sortable: false },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true, sortable: false },
					{ label: 'RECYCLING', key: 'RECYCLING', mobile: true, sortable: false },
					{ label: 'Urban Mining', key: 'URBAN_MINING', mobile: true, sortable: false },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true, sortable: false },
				]
				break
			case 'by_supply_spoc_and_date':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true, sortable: false },
					{ label: '0 to 7', key: '0 to 7', mobile: true, sortable: false },
					{ label: '7 to 14', key: '7 to 14', mobile: true, sortable: false },
					{ label: '14 to 21', key: '14 to 21', mobile: true, sortable: false },
					{ label: '21 to 28', key: '28 to 35', mobile: true, sortable: false },
					{ label: '35 to 42', key: '35 to 42', mobile: true, sortable: false },
					{ label: '42 to 49', key: '42 to 49', mobile: true, sortable: false },
					{ label: '49 to 56', key: '49 to 56', mobile: true, sortable: false },
					{ label: '56 to 63', key: '56 to 63', mobile: true, sortable: false },
					{ label: '63 to 70', key: '63 to 70', mobile: true, sortable: false },
					{ label: '70 to 77', key: '70 to 77', mobile: true, sortable: false },
					{ label: '77 to 84', key: '77 to 84', mobile: true, sortable: false },
					{ label: '84+', key: '84+', mobile: true, sortable: false },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true, sortable: false },
				]
				break
			case 'by_supply_spoc_and_region':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true, sortable: false },
					{ label: 'EAST', key: 'EAST', mobile: true, sortable: false },
					{ label: 'NORTH', key: 'NORTH', mobile: true, sortable: false },
					{ label: 'RAJASTHAN', key: 'RAJASTHAN', mobile: true, sortable: false },
					{ label: 'SOUTH', key: 'SOUTH', mobile: true, sortable: false },
					{ label: 'WEST', key: 'WEST', mobile: true, sortable: false },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true, sortable: false },
				]
				break
			case 'by_supply_spoc_and_platform':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true, sortable: false },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true, sortable: false },
					{ label: 'Cloud Factory', key: 'CLOUD_FACTORY', mobile: true, sortable: false },
					{ label: 'Solar', key: 'SOLAR', mobile: true, sortable: false },
					{ label: 'Ferrous', key: 'FERROUS', mobile: true, sortable: false },
					{ label: 'Non Ferrous', key: 'NON_FERROUS', mobile: true, sortable: false },
					{ label: 'Recycling', key: 'RECYCLING', mobile: true, sortable: false },
					{ label: 'Urban Mining', key: 'URBAN_MINING', mobile: true, sortable: false },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true, sortable: false },
				]
				break
			case 'by_customer':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true, sortable: false },
					{ label: 'Customer Name', key: 'customer_name', mobile: true, sortable: false },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true, sortable: false },
					{ label: 'CLOUD FACTORY', key: 'CLOUD_FACTORY', mobile: true, sortable: false },
					{ label: 'SOLAR', key: 'SOLAR', mobile: true, sortable: false },
					{ label: 'FERROUS', key: 'FERROUS', mobile: true, sortable: false },
					{ label: 'NON FERROUS', key: 'NON_FERROUS', mobile: true, sortable: false },
					{ label: 'RECYCLING', key: 'RECYCLING', mobile: true, sortable: false },
					{ label: 'Urban Mining', key: 'URBAN_MINING', mobile: true, sortable: false },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true, sortable: false },
				]
				break
			default:
				tableColumns = []
				break
		}
		return tableColumns
	}

	const getHeading = (key) => {
		let heading = ''
		switch (key) {
			case 'by_region':
				heading = 'Category Zone Wise Pending (in MT)'
				break
			case 'by_supply_spoc_and_date':
				heading = 'Pending Orders Age Buckets Quantity (in MT)'
				break
			case 'by_supply_spoc_and_region':
				heading = 'Supply SPOC wise Pending (in MT)'
				break
			case 'by_supply_spoc_and_platform':
				heading = 'Pending Orders Supply SPOC Summary (in MT)'
				break
			case 'by_customer':
				heading = 'Pending Orders Supply SPOC and Customer Wise (in MT)'
				break
			default:
				break
		}
		return heading
	}

	const exportHandler = (key, data) => {
		const csvData = dataArrayToCsv(getColumns(key), data)
		const fileName = `${key} report`
		convertDataFile(csvData, fileName)
	}

	return (
		<Wrapper>
			<MainWrapper ShowSideMenu>
				{cardList?.map((item) => {
					return <CardDetail heading={item.key} value={`${item.value}`} hasDefinition={false} icon={getCardIcon(item?.key)} />
				})}
			</MainWrapper>

			{reportsData?.map((item) => {
				return (
					<TableWrapper fullWidth>
						<div>
							<TableHeading>{getHeading(item.key)}</TableHeading>
							<ButtonV2
								style={{ padding: `${Spacings.SPACING_2B} ${Spacings.SPACING_6B}` }}
								onClick={() => exportHandler(item.key, item?.value)}
							>
								{strings('export')}
							</ButtonV2>
						</div>

						<TableV2
							data={item?.value}
							columns={getColumns(item?.key)}
							loading={false}
							rowClickable={false}
							scrollable
							hideFooter
						/>
					</TableWrapper>
				)
			})}
		</Wrapper>
	)
}

export default PendingOrderReports
